<template>
  <div>
    <div class="relative h-[200px] w-full">
      <nav
        class="menu"
        :style="{
          'filter': 'url(#gooey)',
          'width': '100%',
          'height': '100%',
          '--spring-easing':
            'linear(0, 0.88117 15.492%, 1.09261 23.232%, 1.10421 28.713%, 0.99031 49.585%,0.99995)',
        }"
      >
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <input
          id="menu"
          v-model="isOpen"
          type="checkbox"
          class="peer hidden"
          name="menu"
        />
        <label
          class="absolute bottom-4 right-4 sm:bottom-9 sm:right-9 z-10 flex sm:size-14 size-10 scale-110 sm:scale-125 cursor-pointer items-center justify-center rounded-full bg-primary text-white transition-all group duration-1000 [transition-timing-function:var(--spring-easing)]"
          for="menu"
        >
          <UIcon v-if="!isOpen" name="mdi:chat" class="size-6" />
          <UIcon v-else name="mdi:window-close" class="size-6" />
        </label>
        <WhatsAppButton
          label=""
          class="absolute bottom-4 right-4 sm:bottom-9 sm:right-9 flex sm:size-14 size-10 items-center justify-center transition-transform duration-300 ease-in peer-checked:translate-y-[-55px] sm:peer-checked:translate-y-[-80px] peer-checked:duration-1000 peer-checked:[transition-timing-function:var(--spring-easing)]"
        >
        </WhatsAppButton>
        <NuxtLink
          to="mailto:info@quotatrip.com"
          class="absolute bottom-4 right-4 sm:bottom-9 sm:right-9 flex sm:size-14 size-10 items-center justify-center hover:bg-gray-800 rounded-full bg-gray-950 text-white transition-transform duration-300 ease-in peer-checked:translate-y-[-105px] sm:peer-checked:translate-y-[-155px] peer-checked:duration-1000 peer-checked:[transition-timing-function:var(--spring-easing)]"
        >
          <Icon name="lucide:mail" class="size-5" />
        </NuxtLink>
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
const isOpen = ref(false)
</script>
